import { Component, computed, effect, inject, input, output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { DatePickerComponent, FilterHeaderComponent } from '@vectronic/ui';
import { DateHelper, TimeService } from '@vectronic/util';
import { TimeSpanFilterValue } from '../../types/datatable-filter';
@Component({
  selector: 'table-datatable-filter-time',
  templateUrl: './datatable-filter-time.component.html',
  styleUrls: ['./datatable-filter-time.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    FilterHeaderComponent,
    DatePickerComponent,
  ],
})
export class DatatableFilterTimeSpanComponent {
  timeService = inject(TimeService);
  title = input.required<string>();
  value = input<TimeSpanFilterValue | undefined>();
  expanded = input.required<boolean>();
  options = input<{ modes?: TimeSpanFilterValue['mode'][] }>();
  valueChange = output<TimeSpanFilterValue>();
  toggled = output<void>();
  selectOnlyAvailableMode = effect(() => {
    const modes = this.options()?.modes;
    if (modes?.length === 1 && this.value()?.mode !== modes[0]) {
      this.valueChange.emit({ ...this.currentValue(), mode: modes[0] });
    }
  });
  currentValue = computed(() => this.value() || { mode: undefined });
  onModeChange(event: MatRadioChange) {
    const current = this.currentValue();
    const oldMode = current.mode;
    const mode: TimeSpanFilterValue['mode'] = event.value;
    if (mode === oldMode) return;
    let { start, end } = current;
    const timezone = this.timeService.localTimeZone();
    if (mode === 'utc' && oldMode === 'lmt') {
      if (start) start = DateHelper.toTimezone(start, timezone);
      if (end) end = DateHelper.toTimezone(end, timezone);
    } else if (mode === 'lmt' && oldMode === 'utc') {
      if (start) start = DateHelper.fromTimezone(start, timezone);
      if (end) end = DateHelper.fromTimezone(end, timezone);
    }
    const newValue: TimeSpanFilterValue = { ...current, mode, start, end };
    if (newValue.mode === 'recent' && !newValue.recent?.unit) {
      newValue.recent = { ...newValue.recent, unit: 'd' };
    }
    this.valueChange.emit(newValue);
  }

  onDatePickerChange(type: 'start' | 'end', isoDate: string | undefined, mode: 'utc' | 'lmt') {
    const newValue: TimeSpanFilterValue = {
      ...this.currentValue(),
      mode,
      [type]: isoDate,
    };
    this.valueChange.emit(newValue);
  }

  onRecentValueChange(event: Event) {
    const inputVal = (event.target as HTMLInputElement).value;
    const current = this.currentValue();
    const recent = current.recent ?? {};
    const newValue: TimeSpanFilterValue = {
      ...current,
      mode: 'recent',
      recent: {
        ...recent,
        value: inputVal ? Number(inputVal) : undefined,
        unit: recent.unit ?? 'd',
      },
    };
    this.valueChange.emit(newValue);
  }

  onRecentUnitChange(event: MatSelectChange) {
    const current = this.currentValue();
    const newValue: TimeSpanFilterValue = {
      ...current,
      mode: 'recent',
      recent: { ...current.recent, unit: event.value },
    };
    this.valueChange.emit(newValue);
  }
}
